module.exports = __webpack_public_path__ + "static/react-banner-advanced-754648db0598b70d9ec33e6b3309403c.jpg";